<script>
import i18n from "../i18n";

/**
 * Button component
 */
export default {
  components: {
    
  },
  data() {
    return {
    };
  },
  mounted() {
    // i18n.locale = localStorage.getItem('locale');
  },
  methods: {
    visibleLoading: function() {
      return this.requesting;
    },
    visbleIcon: function () {
      return this.icon !== '' && this.requesting ? false : true;
    },
    translate: function(name) {
      return i18n.t(name);
    }
  },
  computed: {
    classObject: function () {
      return  `${this.icon} font-size-18 align-middle me-2`;
    }
  },
  props: {
    icon: {
      type: String,
      default: 'bx bx-lock bx-tada',
    },
    variant: {
      type: String,
      default: 'primary',
    },
    requesting: {
      type: Boolean,
      default: false,
    },
    buttonType: {
      type: String,
      default: 'submit',
    },
    title: {
      type: String,
      default: '',
    },
    titleLocate: {
      type: String,
      default: '',
    },
    disabled: {
      default: false
    }
  },
};
</script>
<template>
  <b-button :type=buttonType :disabled="disabled" :variant=variant @click="$emit('click')" class="btn-block">
    <i v-show="visibleLoading()" class="bx bx-loader-alt bx-spin font-size-16 align-middle me-2" ></i>
    <i v-show="visbleIcon()" v-bind:class="classObject" ></i>
    {{this.title !== '' ? this.title : this.translate(this.titleLocate)}}
  </b-button>
</template>